import type { ScreenSchema } from './types';
const lightboxSchema: ScreenSchema = {
  template: 'lightbox',
  introKeyMode: 'lightbox',
  /** Shell + nested template intros play when the overlay opens (`uc-lightbox`), not on section scroll. */
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    }
  }
};
export default lightboxSchema;
